import { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useLocation, createBrowserRouter, BrowserRouter, RouterProvider } from "react-router-dom";
import './App.css';

import AppLayout from './pages/AppLayout';
import Home from "./pages/Home";
import OurCollections from './pages/OurCollections';
import Contact from './pages/Contact';
import About from './pages/About';
import Customized from './pages/Customized';
import CustomizedDetails from './pages/CustomizedDetail';
import Details from './pages/Details';
import Faqs from './pages/Faqs';
import WhyChooseUs from './pages/WhyChooseUs'; 
import FilterCategory from './pages/FilterCategory';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermAndConditionPage from './pages/TermAndCondition'; 
import PageNotFound from './pages/PageNotFound'; 


 
function App() {
  // Set menu button default state
  const [active, setActive] = useState(false);

  // Function to receive data from child
  const handleChildBody = (data) => {
    setActive(data);
    //console.log("Child Event", data);
  };
  useEffect(() => { 
    
    window.addEventListener('scroll', () => {
      if (active && window.scrollY > 150) {
        document.querySelector('body.home').classList.add('fill');
      } else {
        document.querySelector('body.home').classList.remove('fill');
      }
    });


    if (active) { 
    document.querySelector('body').classList.add('home');
    } else { 
      document.querySelector('body').classList.remove('home');
    }
  }, [active]);
  
   
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <AppLayout />,
        errorElement: <h2>Page not found</h2>,
        children: [
          { path: "/", element: <Home sendBodyClass={handleChildBody} /> },
          { path: "our-collection", element: <OurCollections sendBodyClass={handleChildBody} /> },
          { path: "our-collection/:firstId", element: <FilterCategory sendBodyClass={handleChildBody} /> },
          { path: "our-collection/:firstId/:secondId", element: <Details sendBodyClass={handleChildBody} /> },
          { path: "customized", element: <Customized sendBodyClass={handleChildBody} /> },
          { path: "customized/:id", element: <CustomizedDetails sendBodyClass={handleChildBody} /> },
          { path: "about-us", element: <About sendBodyClass={handleChildBody} /> },
          { path: "contact", element: <Contact sendBodyClass={handleChildBody} /> },
          { path: "faqs", element: <Faqs sendBodyClass={handleChildBody} /> },
          { path: "why-choose-us", element: <WhyChooseUs sendBodyClass={handleChildBody} /> },
          { path: "privacy-policy", element: <PrivacyPolicyPage sendBodyClass={handleChildBody} /> },
          { path: "terms-conditions", element: <TermAndConditionPage sendBodyClass={handleChildBody} /> },
          { path: "*", element: <PageNotFound sendBodyClass={handleChildBody} /> }
        ]
      }
    ],
    {
      future: {
        v7_startTransition: true,
        v7_skipActionErrorRevalidation: true, // Add the flag here to opt-in
      },
    }
  );

  return <RouterProvider router={router} future={{ v7_partialHydration: true }} fallbackElement={<p>Loading...</p>} />;
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}

export default App;
